module.exports = __webpack_public_path__ + "img/free.fcc8bf67.jpg";